import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import Backend from '../../../Layouts/Backend';
import { Alert, Button, Dropdown } from '../../../UI/Common';
import Datagrid from '../../../UI/Datagrid';
import ReactSelect from '../../../UI/ReactSelect';

function MapManagementPage(props) {
  const { t } = useTranslation('app');
  const history = useHistory();
  const roleNames =
    JSON.parse(localStorage.getItem('userProfile')).roleNames || [];
  const isAdmin = roleNames.includes('admin') || roleNames.includes('Admin');
  // const usersDept = JSON.parse(
  //   localStorage.getItem('userProfile'),
  // ).departmentId;
  // function getDept() {
  //   if (props.deptId || props.deptId === 0) {
  //     return props.deptId;
  //   } else return usersDept;
  // }
  // const [deptId, setDeptId] = React.useState(getDept());
  const [deptError, setDeptError] = React.useState(false);
  // React.useEffect(() => props.onChangeDept(deptId), [deptId]);
  function onNewMap(e) {
    e.preventDefault();
    if (props.deptId || props.deptId === 0) {
      history.push(`/configure/map-management/new?deptId=${props.deptId}`);
    } else setDeptError(true);
  }
  return (
    <Backend>
      <div className="content-inner">
        <Alert.Error text={props.errors} />
        <ReactSelect
          required
          isClearable={false}
          containerStyle={{ width: '30%' }}
          isDisabled={!isAdmin}
          label="Department"
          options={props.departments}
          value={props.deptId}
          onChange={({ value }) => props.onChangeDept(value)}
          valueKey="id"
          labelKey="name"
        />
        <Button id="new-map-btn" classes="mb-15" onClick={onNewMap}>
          <i className="md-icon">add</i>
          {t('New Map')}
        </Button>
        <Datagrid
          datagridProps={props.datagridProps}
          ctxMenuOptions={props.ctxMenuOptions}
        />
      </div>
    </Backend>
  );
}

export default MapManagementPage;
